import { db } from './config';
import { getCurrentStaffEmail } from './auth';
import { collection, addDoc, query, where, getDocs, deleteDoc, doc, orderBy } from 'firebase/firestore';

export const addTreatment = async (clientId, recordType, treatmentData) => {
  const staffEmail = getCurrentStaffEmail();
  
  const treatment = {
    clientId,
    recordType,
    ...treatmentData,
    date: treatmentData.date || new Date().toISOString(),
    createdBy: staffEmail,
    createdAt: new Date().toISOString()
  };
  
  const docRef = await addDoc(collection(db, 'treatments'), treatment);
  return { treatmentId: docRef.id, ...treatment };
};

export const getTreatments = async (clientId) => {
  const q = query(
    collection(db, 'treatments'), 
    where('clientId', '==', clientId),
    orderBy('date', 'desc')
  );
  const snapshot = await getDocs(q);
  return snapshot.docs.map(doc => ({ treatmentId: doc.id, ...doc.data() }));
};

export const deleteTreatment = async (treatmentId) => {
  await deleteDoc(doc(db, 'treatments', treatmentId));
};
